module.exports = __webpack_public_path__ + "static/img/share.7ee8b80.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/share.png
// module id = ILAY
// module chunks = 10